module.exports = __webpack_public_path__ + "img/5.02fb5e6.png";